import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

const DATADOG_CLIENT_TOKEN = 'pubc1b9fb3cf47886395e899f78fe952868'
const DATADOG_SITE = 'us3.datadoghq.com'
const DATADOG_SERVICE = 'storefront-ui'

// Read environment configuration from window (set by Rails at runtime)
// This allows one Docker image to be deployed to multiple environments
const railsEnv = (typeof window !== 'undefined' && window.railsEnv) || 'development'
const datadogEnv = (typeof window !== 'undefined' && window.datadogEnv) || railsEnv
const datadogVersion = (typeof window !== 'undefined' && window.datadogVersion) || 'dev-local'

// RUM sample rate (0-100 percentage, 0 = disabled)
const rumSampleRate = (typeof window !== 'undefined' && window.datadogRumSampleRate != null)
  ? Number(window.datadogRumSampleRate) : 0

// Share of RUM-tracked requests that also carry distributed-trace headers
// (0-100). Sessions are already sampled by rumSampleRate, so this defaults to
// 100 rather than compounding a second sampling stage.
const traceSampleRate = (typeof window !== 'undefined' && window.datadogTraceSampleRate != null)
  ? Number(window.datadogTraceSampleRate) : 100

// Share of RUM-sampled sessions that also record a session replay (0-100).
// A second dial independent of rumSampleRate: an environment can run RUM +
// backend-trace linkage with replay OFF. Defaults to 0 so replay is opt-in per
// environment -- replay captures the live DOM, so it stays off outside the
// environments that explicitly enable it.
const replaySampleRate = (typeof window !== 'undefined' && window.datadogReplaySampleRate != null)
  ? Number(window.datadogReplaySampleRate) : 0

datadogLogs.init({
  clientToken: DATADOG_CLIENT_TOKEN,
  site: DATADOG_SITE,
  service: DATADOG_SERVICE,
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
  env: datadogEnv,
  version: datadogVersion,
})

// RUM turns on wherever DD_RUM_SAMPLE_RATE is above 0 -- the env var is the
// per-environment switch, so one image serves every environment. Session replay
// is the separate replaySampleRate dial, so an env can run RUM + backend-trace
// linkage without recording the DOM.
if (rumSampleRate > 0) {
  datadogRum.init({
    applicationId: 'a7516dea-48db-48a9-bbd9-3b9640b14b3c',
    clientToken: DATADOG_CLIENT_TOKEN,
    site: DATADOG_SITE,
    service: DATADOG_SERVICE,
    env: datadogEnv,
    version: datadogVersion,
    sessionSampleRate: rumSampleRate,
    sessionReplaySampleRate: replaySampleRate,
    // Links a browser session to the backend trace it causes: RUM injects
    // distributed-trace headers on matching XHR/fetch, and the Rails side
    // extracts them via RootSDK::Tracing.apply!'s propagation styles.
    //
    // Same-origin is the whole surface -- lib/httpClient issues relative
    // /api/* requests, so every traced call goes back to this app. Matching on
    // window.location.origin keeps it correct in every environment instead of
    // hardcoding per-env hosts.
    //
    // propagatorTypes mirrors RootSDK::Tracing::DISTRIBUTED_PROPAGATION_STYLES
    // so the browser sends both x-datadog-* and W3C traceparent, and the
    // backend extracts whichever it reads first.
    allowedTracingUrls: [
      { match: window.location.origin, propagatorTypes: ['datadog', 'tracecontext'] },
    ],
    traceSampleRate,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  })

  if (replaySampleRate > 0) {
    datadogRum.startSessionReplayRecording()
  }
}
